import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';

export const galleriSampleValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        doctorId: {
          validators: [Validators.required],
        },
      },
    },
  },
};
